module.exports = __webpack_public_path__ + "static/media/mkalogo.7fdf3a7c.png";